import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import {
    fetchGroceryCouponsAPI,
    createGroceryCouponAPI,
    updateGroceryCouponAPI,
    deleteGroceryCouponAPI,
} from "../../../Servicefile/Coupnsapis"; // ✅ Correct import path
import { useLoader } from "../../../../context/LoaderProvider.jsx";

function Grocerycoupons() {
    const [isFormModalOpen, setIsFormModalOpen] = useState(false);
    const [editId, setEditId] = useState(null);
    const [couponsData, setCouponsData] = useState([]);
    const { showLoader, hideLoader } = useLoader();

    const [formData, setFormData] = useState({
        offertype: "",
        couponcode: "",
        discount: "",
        startdate: "",
        enddate: "",
        vendorId: "",
        active: true,
        imageFile: null, // ✅ Store actual file
    });

    const platformFormFields = [
        { label: "Coupon Code", name: "couponcode", type: "text" },
        { label: "Discount Percentage", name: "discount", type: "number" },
        { label: "Start Date", name: "startdate", type: "date" },
        { label: "End Date", name: "enddate", type: "date" },
        { label: "Active Status", name: "active", type: "checkbox" },
        { label: "Coupon Image", name: "imageFile", type: "file" },
    ];

    useEffect(() => {
        fetchCoupons();
    }, []);

    const fetchCoupons = async () => {
        try {
            showLoader();
            const data = await fetchGroceryCouponsAPI();
            setCouponsData(data.data || data);

        } catch (err) {
            console.error("❌ Error fetching coupons:", err);
            alert("Failed to fetch coupons.");
        } finally {
            hideLoader();
        }
    };

    const handleAddRow = () => {
        setFormData({
            offertype: "",
            couponcode: "",
            discount: "",
            startdate: "",
            enddate: "",
            vendorId: "",
            active: true,
            imageFile: null,
        });
        setEditId(null);
        setIsFormModalOpen(true);
    };

    const handleEditRow = (item) => {
        setFormData({
            offertype: item.vendorId === null ? "App_Coupon" : "Vendor_Coupon",
            couponcode: item.code,
            discount: item.discountPercentage,
            startdate: item.startDate.split("T")[0],
            enddate: item.endDate.split("T")[0],
            vendorId: item.vendorId === null ? "" : item.vendorId,
            active: item.active,
            imageFile: null,
        });
        setEditId(item.id);
        setIsFormModalOpen(true);
    };

    const handleDeleteRow = async (id) => {
        if (!window.confirm("Are you sure you want to delete this coupon?")) return;
        try {
            showLoader();
            await deleteGroceryCouponAPI(id);
            alert("✅ Coupon deleted successfully!");
            fetchCoupons();
        } catch (error) {
            console.error("❌ Error deleting coupon:", error);
            alert("❌ Failed to delete coupon.");
        } finally {
            hideLoader();
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData((prev) => ({
                ...prev,
                imageFile: file, // ✅ Save actual file
            }));
        }
    };

    const handleFormSubmit = async () => {
        try {
            const couponData = {
                code: formData.couponcode,
                discountPercentage: parseFloat(formData.discount),
                startDate: formData.startdate
                    ? `${formData.startdate}T00:00:00`
                    : null,
                endDate: formData.enddate
                    ? `${formData.enddate}T23:59:59`
                    : null,
                vendorId:
                    !formData.vendorId || formData.vendorId === ""
                        ? 0
                        : parseInt(formData.vendorId, 10),

                active: formData.active,
                usageCount: 0,
                image: null, // backend handles file
            };

            showLoader();

            if (editId) {
                await updateGroceryCouponAPI(editId, couponData, formData.imageFile);
                alert("✅ Coupon updated successfully!");
            } else {
                await createGroceryCouponAPI(couponData, formData.imageFile);
                alert("✅ Coupon created successfully!");
            }

            setIsFormModalOpen(false);
            setEditId(null);
            fetchCoupons();
        } catch (error) {
            console.error("❌ Error while saving coupon:", error);
            alert(`❌ ${error.message}`);
        }
        finally {
            hideLoader();
        }
    };

    return (
        <div>
            {/* Add Button */}
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "2px" }}>
                <button onClick={handleAddRow} style={addButtonStyle}>
                    Add+
                </button>
            </div>

            {/* Coupon Table */}
            <table style={tableStyle}>
                <thead>
                    <tr>
                        <th style={tableHeaderStyle}>S.No</th>
                        <th style={tableHeaderStyle}>Offer Type</th>
                        <th style={tableHeaderStyle}>Code</th>
                        <th style={tableHeaderStyle}>Image</th>
                        <th style={tableHeaderStyle}>Discount %</th>
                        <th style={tableHeaderStyle}>Start Date</th>
                        <th style={tableHeaderStyle}>End Date</th>
                        <th style={tableHeaderStyle}>Active</th>
                        <th style={tableHeaderStyle}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {couponsData
                        .filter((item) => item.vendorId === null || item.vendorId === 0)
                        .map((item, index) => (
                            <tr key={item.id}>
                                <td style={tableCellStyle}>{index + 1}</td>
                                <td style={tableCellStyle}>App_Coupon</td>
                                <td style={tableCellStyle}>{item.code}</td>
                                <td style={tableCellStyle}>
                                    {item.image ? (
                                        <img
                                            src={item.image.startsWith("http")
                                                ? item.image
                                                : `data:image/png;base64,${item.image}`}
                                            alt="Coupon"
                                            style={{
                                                width: "60px",
                                                height: "60px",
                                                objectFit: "cover",
                                                borderRadius: "6px",
                                            }}
                                        />
                                    ) : (
                                        "No Image"
                                    )}
                                </td>
                                <td style={tableCellStyle}>{item.discountPercentage}</td>
                                <td style={tableCellStyle}>
                                    {item.startDate ? item.startDate.split("T")[0] : "-"}
                                    {item.endDate ? item.endDate.split("T")[0] : "-"}
                                    {item.startDate.split("T")[0]}
                                </td>
                                <td style={tableCellStyle}>
                                    {item.endDate.split("T")[0]}
                                </td>
                                <td style={tableCellStyle}>
                                    {item.active ? "Yes" : "No"}
                                </td>
                                <td style={tableCellStyle}>
                                    <FaEdit
                                        style={{
                                            color: "blue",
                                            cursor: "pointer",
                                            marginRight: "10px",
                                        }}
                                        onClick={() => handleEditRow(item)}
                                    />
                                    <FaTrash
                                        style={{ color: "red", cursor: "pointer" }}
                                        onClick={() => handleDeleteRow(item.id)}
                                    />
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>

            {/* Modal */}
            {isFormModalOpen && (
                <div style={modalOverlay}>
                    <div style={modalContent}>
                        <h3 style={{ color: "#b15cd6" }}>
                            {editId ? "Edit Coupon" : "Add Coupon"}
                        </h3>

                        {platformFormFields.map((field) => (
                            <div key={field.name} style={{ marginBottom: "10px" }}>
                                {field.type === "checkbox" ? (
                                    <label
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            name={field.name}
                                            checked={formData[field.name]}
                                            onChange={handleChange}
                                        />
                                        {formData[field.name]
                                            ? "Active"
                                            : "Inactive"}
                                    </label>
                                ) : field.type === "file" ? (
                                    <>
                                        <label>{field.label}:</label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleImageChange}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <label>{field.label}:</label>
                                        <input
                                            type={field.type}
                                            name={field.name}
                                            value={formData[field.name]}
                                            onChange={handleChange}
                                            style={inputStyle}
                                        />
                                    </>
                                )}
                            </div>
                        ))}

                        <div
                            style={{ marginTop: "20px", textAlign: "right" }}
                        >
                            <button
                                onClick={handleFormSubmit}
                                style={saveButtonStyle}
                            >
                                Save
                            </button>
                            <button
                                onClick={() => setIsFormModalOpen(false)}
                                style={closeButtonStyle}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

// 🎨 Styles
const addButtonStyle = {
    padding: "8px 16px",
    backgroundColor: "#b15cd6",
    color: "white",
    border: "none",
    cursor: "pointer",
    borderRadius: "5px",
    width: "100px",
    fontWeight: "bold",
};
const tableStyle = { width: "100%", borderCollapse: "collapse" };
const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "white",
    padding: "8px",
};
const tableCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    padding: "6px",
};
const modalOverlay = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
};
const modalContent = {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "8px",
    width: "450px",
    maxWidth: "90%",
    overflowY: "auto",
};
const inputStyle = {
    width: "100%",
    padding: "8px",
    boxSizing: "border-box",
    borderRadius: "4px",
    border: "1px solid #ccc",
};
const saveButtonStyle = {
    backgroundColor: "#28a745",
    color: "white",
    padding: "10px 15px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
    marginRight: "10px",
};
const closeButtonStyle = {
    backgroundColor: "#6c757d",
    border: "none",
    color: "#fff",
    padding: "10px 15px",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
};

export default Grocerycoupons;
